// extracted by mini-css-extract-plugin
export var footer = "_nw-0";
export var inherit = "_nw-1";
export var input = "_nw-2";
export var modalContent = "_nw-3";
export var quillEditor = "_nw-4";
export var subtitle = "_nw-5";